import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import {
  isFailure,
  Protection,
  ProtectionServiceErrorCode,
} from "@sportal/api";

import { Notificator } from "../../../../components/notification";
import { FIXED_PROFILES } from "../../../../store/profiles/fixedProfiles";
import { loadCategories } from "../../../../store/categories/categories.actions";
import { loadSharedProtections } from "../../../../store/protections/protections.actions";
import { getCustomProtections } from "../../../profiles/components/webFilters/webFilters.actions";
import { getNames } from "../../../../store/categories/categories.helpers";

export const load = () => (dispatch) => {
  dispatch(loadCategories());
  dispatch(loadSharedProtections());
  dispatch(getCustomProtections());
};

export const fetchTableData =
  (url) =>
  async (dispatch, getState, { api }) => {
    if (_.isEmpty(url)) return;

    const requestData = { type: "fqdn", node: url },
      { profiles, ssProfiles, webFilters, protections, categories } =
        getState(),
      customProtections = webFilters.customProtections;

    dispatch(removeError());

    const result = await api.ssm.protection.getCategoriesByUrl(requestData);

    if (isFailure(result)) {
      switch (result.error.code) {
        case ProtectionServiceErrorCode.INTERNAL_SERVER_ERROR: {
          dispatch(Notificator.error("domain_lookup_server_error"));
          break;
        }
        case ProtectionServiceErrorCode.PARSING_ERROR: {
          dispatch(
            processDataFailure(
              <FormattedMessage id={"domain_lookup_parse_failed"} />
            )
          );
          break;
        }
        default: {
          dispatch(Notificator.error("domain_lookup_smth_wrong"));
        }
      }
      dispatch(fetchTableDataFailure(result.error));

      return Promise.reject();
    }
    const tableData = processData(
      result.data.content,
      profiles,
      protections,
      customProtections,
      ssProfiles,
      categories
    );

    dispatch(processDataSuccess(tableData));
  };

const getValidCategoryNames = (categories, securityCategories) => {
  const categoryNames = categories.map(getNames);

  return [...categoryNames, ...securityCategories];
};

export const SecurityCategoryKeys = {
  Spam: "tpsvc_spam",
  Botnet: "tpsvc_botnet",
  Phishing: "tpsvc_phishing",
  Malware: "tpsvc_malware",
  Unidentified: "tpsvc_unidentified",
};

export function processData(
  categories,
  profiles,
  protections,
  customProtections,
  ssProfiles,
  categoriesFromStore
) {
  let tableData = [];

  const validCategoryNames = getValidCategoryNames(
    categoriesFromStore,
    Object.values(SecurityCategoryKeys)
  );

  _.each(categories, (category) => {
    if (!_.includes(validCategoryNames, category.name)) return;

    let associatedProfiles = [];
    let associatedSSProfiles = [];
    const categoriesForSSProfiles = [
      SecurityCategoryKeys.Malware,
      SecurityCategoryKeys.Phishing,
      SecurityCategoryKeys.Spam,
      SecurityCategoryKeys.Unidentified,
    ];

    _.each(profiles.saved.list, (profile) => {
      let isFixed = _.some(FIXED_PROFILES, { name: profile.name }),
        blocked =
          profile.protection !== Protection.Custom
            ? protections.list[profile.protection].categories
            : customProtections[profile.id];

      if (!profile.hidden) {
        if (_.includes(categoriesForSSProfiles, category.name)) {
          associatedSSProfiles.push({
            name: isFixed ? profile.type : profile.name,
            ssStatus: ssProfiles.saved.list[profile.id].enabled,
            isFixed,
          });
        }
      }

      if (_.includes(blocked, category.name)) {
        associatedProfiles.push({
          name: isFixed ? profile.type : profile.name,
          isFixed,
        });
      }
    });

    tableData.push({
      category,
      associatedProfiles,
      associatedSSProfiles,
    });
  });

  return tableData;
}

export const SEARCH_URL_CHANGE = "[DOMAIN_LOOKUP] SEARCH_URL_CHANGE";
export const PROCESS_DATA_SUCCESS = "[DOMAIN_LOOKUP] PROCESS_DATA_SUCCESS";
export const PROCESS_DATA_FAILURE = "[DOMAIN_LOOKUP] PROCESS_DATA_FAILURE";
export const FETCH_TABLE_DATA_FAILURE =
  "[DOMAIN_LOOKUP] FETCH_TABLE_DATA_FAILURE";
export const REMOVE_ERROR_MESSAGE = "[DOMAIN_LOOKUP] REMOVE_ERROR_MESSAGE";
export const CLEAR_ALL = "[DOMAIN_LOOKUP] CLEAR_ALL";

export const searchUrlChange = (searchUrl) => ({
  type: SEARCH_URL_CHANGE,
  payload: { searchUrl },
});
export const processDataSuccess = (tableData) => ({
  type: PROCESS_DATA_SUCCESS,
  payload: { tableData },
});
export const processDataFailure = (errorMessage) => ({
  type: PROCESS_DATA_FAILURE,
  payload: { errorMessage },
});
export const removeError = () => ({
  type: REMOVE_ERROR_MESSAGE,
});
export const clearAllData = () => ({
  type: CLEAR_ALL,
});
export const fetchTableDataFailure = (error) => ({
  type: FETCH_TABLE_DATA_FAILURE,
  payload: { error },
});
